import React from "react"
import styled from "styled-components"

import {
  List,
  Item,
  Icon,
  StyledLink,
  NoPageLink,
  SubList,
  SubItem,
  SubLink,
} from "./styles"
import Expand from "./../../images/expand.svg"

const IconComponent = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="512px"
    height="512px"
    viewBox="0 0 306 306"
  >
    <polygon
      points="270.3,58.65 153,175.95 35.7,58.65 0,94.35 153,247.35 306,94.35"
      fill="#121453"
    />
  </Icon>
)

class Navigation extends React.Component {
  render() {
    const { theme, isTop, page } = this.props

    const homeTop = isTop && page === "home"

    return (
      <List theme={theme} isTop={isTop} homeTop={homeTop}>
        <Item>
          <NoPageLink className="no-page-link">About us</NoPageLink>
          <IconComponent />
          <SubList>
            <SubItem>
              <SubLink to="/about-us/company-history/" activeClassName="active">
                Company History
              </SubLink>
            </SubItem>
            <SubItem>
              <SubLink to="/about-us/leadership/" activeClassName="active">
                Leadership
              </SubLink>
            </SubItem>
          </SubList>
        </Item>

        <Item>
          <StyledLink to="/technology/" activeClassName="active">
            Technology
          </StyledLink>
          <IconComponent />
          <SubList>
            <SubItem>
              <SubLink
                to="/technology/nanogel-drug-delivery-platform/"
                activeClassName="active"
              >
                Nanogel Drug Delivery Platform
              </SubLink>
            </SubItem>
            <SubItem>
              <SubLink
                to="/technology/nanogels-in-drug-development/"
                activeClassName="active"
              >
                Rapid Response Vaccine Platform
              </SubLink>
            </SubItem>
          </SubList>
        </Item>

        <Item>
          <StyledLink to="/therapeutic-applications/" activeClassName="active">
            Vaccines and Therapeutics
          </StyledLink>
        </Item>

        <Item>
          <NoPageLink className="no-page-link">Partnering</NoPageLink>
          <IconComponent />
          <SubList>
            <SubItem>
              <SubLink
                to="/partnering/partnership-opportunities/"
                activeClassName="active"
              >
                Partnership opportunities
              </SubLink>
            </SubItem>
            <SubItem>
              <SubLink to="/partnering/projects/" activeClassName="active">
                Projects
              </SubLink>
            </SubItem>
          </SubList>
        </Item>

        <Item>
          <StyledLink to="/news/" activeClassName="active">
            News
          </StyledLink>
        </Item>

        <Item>
          <StyledLink to="/contact/" activeClassName="active">
            Contact
          </StyledLink>
        </Item>
      </List>
    )
  }
}

export default Navigation
